import React from 'react';
import AuthorImage from '@assets/images/author-block-image-fallback.jpg';
import AuthorStars from '@assets/icons/AuthorStars';
import {
	AuhtorInformation,
	AuthorBlock,
	AuthorBlockText,
	AuthorContainer,
	AuthorName,
	AuthorWritten,
} from './authorCard.styled';
import parse from 'html-react-parser';

interface AuthorCardProps {
	author?: string;
	writtenBy?: string;
	authorImage?: string;
	rating?: string;
	aboutAuthor: string;
}

const AuthorCard: React.FC<AuthorCardProps> = ({ author, writtenBy, authorImage, rating, aboutAuthor }) => {
	return (
		<AuthorContainer>
			<AuthorBlock>
				<img src={authorImage ? authorImage : AuthorImage} loading="lazy" alt="Post Author" />
				<AuhtorInformation>
					{rating ? <img src={rating} alt="Rating" /> : <AuthorStars />}
					<AuthorWritten>{writtenBy}</AuthorWritten>
					<AuthorName>{author}</AuthorName>
				</AuhtorInformation>
			</AuthorBlock>
			<AuthorBlockText>{parse(aboutAuthor)}</AuthorBlockText>
		</AuthorContainer>
	);
};

export default AuthorCard;
